import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { Subject, takeUntil } from 'rxjs';
import { FieldDictionaryListService } from 'src/app/tabms/services/global/field-dictionary-list.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';
import { TabConst } from 'src/app/tabms/tab-consts';
import { FormControl } from '@angular/forms';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { FieldDicHelperService } from 'src/app/tabms/services/global/field-dic-helper.service';

// Date format configuration for dd/MM/yyyy
export const DD_MM_YYYY_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrl: './date-picker.component.scss',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_FORMAT },
  ],
})
export class DatePickerComponent implements OnInit, OnDestroy {
  @Input() fieldName
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE // New input for size control
  @Input() control: FormControl
  @Output() selected = new EventEmitter<string>();
  @Input() validate: boolean = false
  @Input() disabled: boolean = false //disable calendar
  @Input() minDate: any = null;

  systemMenuId
  currentLang
  label: string

  private destroy$: Subject<void> = new Subject<void>();

  get allClasses() {
    return {
      'w-100': true,
      'm-t-5': true,
      'mat-form-field-compact': this.size === 'compact',
      'mat-form-field-xs': this.size === 'xs'
    }
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private baseService: BaseService,
    private themeLayoutService: ThemeLayoutService,
    private fieldDicHelperService: FieldDicHelperService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();

    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe({
      next: (params) => {
        this.systemMenuId = params['id'];
      }
    })

    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        (dir === RTL) ? this.currentLang = 'ar' : 'en'
        // this.getFieldData();
      }
    })
  }


  ngOnInit(): void {
    this.loadFieldData();

    this.baseService.createFormDisplay
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          // console.log('subscribe createFormDisplay in input', res);

          if (res?.show && res?.id === null) {
            this.loadFieldData(); // create only
          }
        },
      });
  }

  private loadFieldData() {
    // debugger
    this.fieldDicHelperService
      .getFieldData(this.fieldName, this.systemMenuId, this.validate, this.control, this.currentLang)
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ placeholder, defaultValue, type, disabled }) => {
        // debugger
        this.label = placeholder;
        if (defaultValue !== null && defaultValue !== undefined) {
          this.control.patchValue(defaultValue, { emitEvent: false, onlySelf: true });
        }
        // console.log('disabled', disabled);

        if (disabled) {
          this.control?.disable({ emitEvent: false });
        }
      });
  }


  //select Date
  selectedDate(event): void {
    // console.log(event);
    const value = event.value
    if (!value) {
      this.selected.emit(null);
      return
    }
    const date = new Date(value);
    const selectedDate = date.toLocaleDateString('en-CA');
    this.selected.emit(selectedDate);
  }

  //destroy region
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
